<template>
  <router-view/>
</template>

<style lang="scss">
</style>
<script setup>
</script>
